module.exports = __webpack_public_path__ + "img/19_plugged_in.cf210a57.jpg";